/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import * as pagosActions from '../../../actions/pagosActions';
import * as inscripcionActions from '../../../actions/inscripcionActions';
import BorrarInscripcion from './BorrarInscripcion';
import ModalSiNo from '../../common/ModalBorrarInscripcion';
import * as paginaActions from '../../../actions/paginaActions';
import * as usuarioActions from '../../../actions/usuarioActions';
import { Segment} from 'semantic-ui-react';
import moment from 'moment';
import {getMargenes} from '../../../util/';
import $ from 'jquery';


class ManagePagosPendientes extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            busqueda:"",
            inscripciones:[],
            showModalBorrar:false,
            borrar:{}
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.idCurso;
        let pageInfo={ 
            page:'borrarInscripcion', 
            idioma:this.props.idioma     
        }; 
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
       
            
      
    	
    }
    
    onShowModalBorrar=(id)=>{
        
        let index = this.state.inscripciones.findIndex(insc=>insc.id == id);
        
        let borrar =Object.assign({}, this.state.inscripciones[index]);
        
        
        //console.log(borrar);
        let showModalBorrar=this.state.showModalBorrar;
        
        
        this.setState({showModalBorrar:!showModalBorrar, borrar:borrar});
        
    }
    
    oncloseModal=()=>{
        let borrar={};
        let showModalBorrar=this.state.showModalBorrar;
        this.setState({showModalBorrar:!showModalBorrar, borrar:borrar});
        
        
    }
    
    onBorrar=()=>{
        let borrar = this.state.borrar;
        
        this.props.inscripcionActions.borrarPermanente(borrar.id, this.props.user).then( borrado=>{
            this.setState({borrado:borrado});
            this.setState({borrar:borrar});
            this.buscar();
            this.oncloseModal();
        })
        .catch(error=>{
          toastr.error(error);
        });
                
        
    
    }
   
    
    buscar=()=>{
            let correo = this.state.busqueda;
       
            this.props.inscripcionActions.getInscripcionByUsuarioList(correo, this.props.user).then( inscripciones=>{
                 
                    this.setState({inscripciones:inscripciones});
            })
            .catch(error=>{
              toastr.error(error);
            });
        
        
    }
    
    handleChange=(event, data)=>{
        
        this.setState({busqueda:data.value});
        
    }
       
    render() {	
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        //console.log(this.state.borrar)
        return (
            <Segment  style={margenes}>
                <BorrarInscripcion 
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    strings={this.props.strings}
                    onBuscar={this.buscar}
                    onChange={this.handleChange}
                    datos={this.state.inscripciones}
                    onShowModalBorrar={this.onShowModalBorrar}
                 
                />
            
               <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.onBorrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente, una vez borrado no será posible recuperar los datos?"}
                    inscripcion={this.state.borrar}
                    titulo={this.state.strings?this.state.strings["Inscripcion"]:""}
                />    
            
            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings, 
        form:state.form,
        cursoCombo:state.cursoCombo,
        usuarioCombo:state.usuarioCombo,
        tipomonedaCombo:state.tipomonedaCombo,
        cursotipomonedaCombo:state.cursotipomonedaCombo,
        pagoReporte:state.pagoReporte
    }

}

function mapDispatchToProps(dispatch){

	return {   
            paginaActions: bindActionCreators(paginaActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch),
            inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
            pagosActions: bindActionCreators(pagosActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManagePagosPendientes);